// extracted by mini-css-extract-plugin
export default {"root":"root___Dbo7e","size_s":"size_s___DCSjU","size_m":"size_m___b2dgH","size_l":"size_l___SqCL4"};